// extracted by mini-css-extract-plugin
module.exports =  {"highlight":"jut__TextHighlight__highlight","screenReaderLabel":"jut__TextHighlight__screenReaderLabel"};